import { render, staticRenderFns } from "./ReporteGeneralPqrs.vue?vue&type=template&id=1e07a983&scoped=true"
import script from "./ReporteGeneralPqrs.vue?vue&type=script&lang=js"
export * from "./ReporteGeneralPqrs.vue?vue&type=script&lang=js"
import style0 from "./ReporteGeneralPqrs.vue?vue&type=style&index=0&id=1e07a983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e07a983",
  null
  
)

export default component.exports